import {
	REFRESH_CATEGORIES,
	SET_CATEGORIES,
} from './types'

const initialState = {
	categories: [],
	refresh: false,
	initialize: true
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_CATEGORIES:
			return {
				...state,
				refresh: true,
				initialize: true,
				categories: [],
			}
		
		case SET_CATEGORIES:
			return {
				...state,
				refresh: false,
				initialize: false,
				categories: payload
			}

		default:
			return state;

	}

}

export default reducer